/**
 * SKU统计 Hook
 */
import { useMemo } from 'react';
import { SKU } from '../../../types/core-types';

export const useSKUStats = (skus: SKU[]) => {
    return useMemo(() => {
        const total = skus.length;
        const thisMonth = skus.filter((sku) => {
            const created = new Date(sku.created_at);
            const now = new Date();
            return created.getMonth() === now.getMonth() && created.getFullYear() === now.getFullYear();
        }).length;
        const analyzed = skus.filter((sku) => sku.id).length;

        return { total, thisMonth, analyzed };
    }, [skus]);
};
